export const ONESIGNAL_APP_ID = "3b08a3d6-6ece-4c9f-9510-9c4c07551ab8";
export const PUBLIC_API_URL = "https://geladaemcasaapp.com.br/ws/";
